import { RSAA } from 'redux-api-middleware';

import * as types from '../actionTypes';
import { bet } from '../selectors';

export function changeCurrentBet(betId) {
  return {
    type: types.CHANGE_CURRENT_BET,
    payload: betId,
  };
}

export function changeCurrentBetPresetBasedAt(presetBetBasedAt) {
  return {
    type: types.SET_CURRENT_BET_PRESET_BASED_AT,
    payload: presetBetBasedAt,
  };
}

export function clearCurrentBet() {
  return {
    type: types.CLEAR_CURRENT_BET,
  };
}

export function fetchQuickOverview() {
  return {
    [RSAA]: {
      bailout: state =>
        bet.getCurrentBetId(state) == null || bet.isQuickOverviewLoading(state),
      endpoint: 'report/quickOverview',
      headers: state => ({ betId: bet.getCurrentBetId(state) }),
      types: [
        types.REQUEST_QUICK_OVERVIEW,
        types.RECEIVE_QUICK_OVERVIEW,
        types.RECEIVE_QUICK_OVERVIEW_ERROR,
      ],
    },
  };
}

export function clearQuickOverview() {
  return {
    type: types.CLEAR_QUICK_OVERVIEW,
  };
}
